// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__bsa3Z","inner":"Footer_inner__hWbUC","links":"Footer_links__uTMUu"};